export enum PropertyMediaImageActionTypes {
  SET_MEDIA_IMAGE_LIST = '[MEDIA IMAGES] Set list',
  SAVE_MEDIA_IMAGES = '[MEDIA IMAGES] Save images',
  UPDATE_IMAGE = '[MEDIA IMAGES] Update image',
  DELETE_IMAGE = '[MEDIA IMAGES] Delete image',
  UPDATE_POSITION = '[MEDIA IMAGES] Update image position',
  CLEAR_HIGHLIGHTED = '[MEDIA IMAGES] Clear highlight imageId',
};
